import React from 'react';
import myResume from "../../assets/my-resume.pdf";

const CTA = () => {
  return (
    <div className='cta'>
        <a className='btn' href={myResume} download>Download CV</a>
        <a className='btn btn-primary' href="#contact">Let's Talk</a>
    </div>
  )
}

export default CTA